import { Map, Set } from 'immutable';
import { normalizeJobData } from '@saucelabs/sl-util-helpers';

import * as constants from './../constants';
import { getDisplayMetaFromJob, getDisplayaMetaFromSession } from './utils';
import { SessionRecord } from './../records';

const initialState = new SessionRecord({});

const sessionNotFoundCopy = 'This Live Session can only be accessed by users who are in the ' +
  'same organization as the owner of the link. If you are sure you ' +
  'have the correct URL, contact the user who shared the link with you.';


const desktopSessionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.DESKTOP_SESSION_CREATE.REQUEST: {
      const displayMeta = getDisplayaMetaFromSession(payload.configuration);

      return state.mergeIn(['metadata'], displayMeta);
    }
    case constants.DESKTOP_SESSION_CREATE.SUCCESS: {
      const metadata = state.get('metadata');

      return state.withMutations((mutable) => {
        const session = mutable
          .merge({ ...payload, status: constants.SESSION_STATUS_NEW })
          .mergeIn(['metadata'], Map(metadata));

        mutable.merge(session);
      });
    }
    case constants.DESKTOP_SESSION_GET.SUCCESS: {
      const normalizedPayload = normalizeJobData(payload);

      return state.withMutations((mutable) => {
        mutable.merge({
          status: normalizedPayload.status,
          job_id: normalizedPayload.job_id,
          task_id: normalizedPayload.id,
          error: normalizedPayload.error || false,
          members: Set(normalizedPayload.members),
        }).mergeIn(['metadata'], Map({
          url: normalizedPayload.url,
          os: normalizedPayload.os,
          osVersion: normalizedPayload.osVersion,
          tunnel: normalizedPayload.tunnel,
          resolution: normalizedPayload.resolution,
          browser: normalizedPayload.browser,
          browserVersion: normalizedPayload.browserVersion,
          owner: normalizedPayload.owner,
        }));
      });
    }
    case constants.DESKTOP_SESSION_GET.FAILURE: {
      if (!payload || !payload.response) {
        return state;
      }

      const { data, status } = payload.response;

      if (status >= 400 && status < 500) {
        return state.merge({
          status: constants.SESSION_STATUS_ERROR,
          error: sessionNotFoundCopy,
        });
      }

      return state.set('error', data.error || data.message);
    }
    case constants.DESKTOP_SESSION_JOB_INITIAL_UPDATE:
      return state.set('task_id', payload.taskId);
    case constants.DESKTOP_SESSION_JOB_GET.SUCCESS: {
      const metadata = getDisplayMetaFromJob(payload);
      return state.withMutations((mutable) => (
        mutable
          .merge({
            video_secret: payload.video_secret,
            manual: payload.manual,
            public: payload.public,
            error: payload.error || false,
          })
          .mergeIn(['metadata'], Map(metadata))
      ));
    }
    case constants.DESKTOP_SESSION_DELAY: {
      return state
        .merge({
          _formData: payload,
          status: constants.SESSION_STATUS_WAITING,
        });
    }
    case constants.DESKTOP_SESSION_AUTO_LAUNCH_TOGGLE: {
      return state.update('_autoLaunch', (current) => !current);
    }
    case constants.DESKTOP_SESSION_CLOSE.SUCCESS:
    case constants.DESKTOP_SESSION_CLOSE.FAILURE:
      return initialState;
    default:
      return state;
  }
};

export default desktopSessionReducer;
export { initialState };
